import React from 'react';
import { Navigation2 } from 'lucide-react';
import { TimelinePoint } from './TimelinePoint';
import { getPOIIcon } from '../../../utils/poiHelpers';
import { logInfo } from '../../../../../utils/logger';

export const Timeline = ({ route = null, pois = [], showAllPois = false }) => {
  // Log the data we're working with
  React.useEffect(() => {
    if (showAllPois) {
      logInfo(`Showing all ${pois.length} POIs in timeline`);
    } else if (route) {
      logInfo(`Showing route timeline for route ${route.id} with ${pois.filter(p => p.routeId === route.id).length} POIs`);
    }
  }, [route, pois, showAllPois]);

  if (showAllPois) {
    return (
      <>
        <div className="px-4 py-3 bg-[#2A2B2E] border-t border-b border-gray-700">
          <h3 className="text-lg font-medium text-white">
            Points of Interest ({pois.length})
          </h3>
        </div>
        <div className="bg-[#1a1a1a]">
          <div className="p-4 space-y-4 min-h-[240px]">
            <div className="relative">
              <div className="absolute left-4 top-8 bottom-8 w-px border-l-2 border-dashed border-gray-600" />
              
              {pois?.map((poi) => (
                <TimelinePoint
                  key={poi.id}
                  point={poi}
                  type="poi"
                  Icon={getPOIIcon(poi.type)}
                  distance={0}
                  timestamp={poi.createdAt}
                />
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }

  // Filter and sort POIs for current route
  const routePois = React.useMemo(() => {
    if (!route) return [];
    return pois?.filter(Boolean)
      .filter(poi => poi.routeId === route?.id)
      .sort((a, b) => (a.distanceFromStart || 0) - (b.distanceFromStart || 0));
  }, [pois, route]);
  
  return (
    <>
      <div className="px-4 py-3 bg-[#2A2B2E] border-t border-b border-gray-700">
        <h3 className="text-lg font-medium text-white">
          Points of Interest ({routePois.length})
        </h3>
      </div>
      <div className="bg-[#1a1a1a]">
        <div className="p-4 space-y-4 min-h-[240px]">
          <div className="relative">
            <div className="absolute left-4 top-8 bottom-8 w-px border-l-2 border-dashed border-gray-600" />
            
            {/* Origin */}
            {route && (
              <TimelinePoint
                point={route}
                type="origin"
                Icon={Navigation2}
                distance={0}
                timestamp={route?.createdAt}
              />
            )}

            {/* POIs */}
            {routePois.map((poi) => (
              <TimelinePoint
                key={poi.id}
                point={poi}
                type="poi"
                Icon={getPOIIcon(poi.type)}
                distance={poi.distanceFromStart || 0}
              />
            ))}

            {/* Destination */}
            {route && (
              <TimelinePoint
                point={route}
                type="destination"
                Icon={Navigation2}
                distance={route?.distance || 0}
                timestamp={route?.updatedAt}
              />
            )}
          </div>
        </div>
      </div>
      {/* Add bottom padding to ensure content is visible */}
      <div className="h-16"></div>
    </>
  );
};